export interface ModalState {
    modalName: string;
    isOpen: boolean;
    data: Record<string, any>;
}

export interface OpenModalPayload {
    modalName: string;
    data?: Record<string, any>;
}

export const initialState: ModalState = {
    modalName: "",
    isOpen: false,
    data: {},
};
